import React from 'react';
import { formatDateStr } from '@gp/utils/common';
import ReviewCalendar, { IReviewCalendarProps } from '../../../components/Calendar/ReviewCalendar';
import { CARD_TITLE } from '../../../components/Calendar/utils';
import { TABLE_WIDTH_IN_SMALL_SCREEN, SMALL_WIDTH_COLUMN_WIDTH_IN_SMALL_SCREEN } from '../../../constants';
import {
  PRIORITY_COLUMN_WIDTH_IN_SMALL_SCREEN,
  MILESTONE_COLUMN_WIDTH_IN_SMALL_SCREEN,
  MILESTONE_DATE_COLUMN_WIDTH_IN_SMALL_SCREEN,
  PRIORITY_COLUMN_WIDTH,
  MILESTONE_COLUMN_WIDTH,
  MILESTONE_DATE_COLUMN_WIDTH,
} from '../../../components/Calendar/constants';
import { DPS_REPORT_MODULE_KEY } from '../../constants';

import type { IBaseProps } from '@home/types/common';
import type { IRecord } from '@gp/types/global';
import type { IDPSReportCalendarValue } from '@gp/types/dpsReport/v3';

import './index.scss';

interface IReviewCalendarV3Props extends IBaseProps, Omit<IReviewCalendarProps, 'value'> {
  // 标题
  title?: string;
  value: IDPSReportCalendarValue;
}

const PROJECT_COLUMN_WIDTH_IN_SMALL_SCREEN =
  SMALL_WIDTH_COLUMN_WIDTH_IN_SMALL_SCREEN - PRIORITY_COLUMN_WIDTH_IN_SMALL_SCREEN;

const STATUS_COLUMN_WIDTH_IN_SMALL_SCREEN = 180;

const COMMON_COLUMN_WIDTH_IN_SMALL_SCREEN =
  (TABLE_WIDTH_IN_SMALL_SCREEN -
    (PRIORITY_COLUMN_WIDTH_IN_SMALL_SCREEN +
      PROJECT_COLUMN_WIDTH_IN_SMALL_SCREEN +
      MILESTONE_COLUMN_WIDTH_IN_SMALL_SCREEN +
      MILESTONE_DATE_COLUMN_WIDTH_IN_SMALL_SCREEN +
      STATUS_COLUMN_WIDTH_IN_SMALL_SCREEN)) /
  2;

const PROJECT_COLUMN_WIDTH = `${(PROJECT_COLUMN_WIDTH_IN_SMALL_SCREEN / TABLE_WIDTH_IN_SMALL_SCREEN) * 100}%`;

const STATUS_COLUMN_WIDTH = `${(STATUS_COLUMN_WIDTH_IN_SMALL_SCREEN / TABLE_WIDTH_IN_SMALL_SCREEN) * 100}%`;

const COMMON_COLUMN_WIDTH = `${(COMMON_COLUMN_WIDTH_IN_SMALL_SCREEN / TABLE_WIDTH_IN_SMALL_SCREEN) * 100}%`;

const COLUMN_WIDTH_MAPPING: IRecord<string | undefined> = {
  priority: PRIORITY_COLUMN_WIDTH,
  project_id: PROJECT_COLUMN_WIDTH,
  business_owner: COMMON_COLUMN_WIDTH,
  pteam: COMMON_COLUMN_WIDTH,
  milestone: MILESTONE_COLUMN_WIDTH,
  date: MILESTONE_DATE_COLUMN_WIDTH,
  status: STATUS_COLUMN_WIDTH,
};

const ReviewCalendarV3: React.FC<IReviewCalendarV3Props> = (props) => {
  const { value, title, ...restProps } = props;
  const { start_date: startDate, end_date: endDate, list: calendars } = value || {};
  const startDateFormatted = formatDateStr(startDate, 'YYYY-MM');
  const endDateFormatted = formatDateStr(endDate, 'YYYY-MM');

  const titleDate = (
    <span className="dbg-dps-report-calendar-card-title">
      {title || CARD_TITLE}
      {!!startDateFormatted && !!endDateFormatted && (
        <span className="dbg-dps-report-calendar-card-sub-title">
          {startDateFormatted}~{endDateFormatted}
        </span>
      )}
    </span>
  );

  return (
    <ReviewCalendar
      {...restProps}
      moduleKey={DPS_REPORT_MODULE_KEY.CALENDARS}
      columnWidthMapping={COLUMN_WIDTH_MAPPING}
      title={titleDate}
      value={calendars || []}
    />
  );
};

export default ReviewCalendarV3;
